import { render, staticRenderFns } from "./HeaderComparison.vue?vue&type=template&id=121f4b85&scoped=true&"
import script from "./HeaderComparison.vue?vue&type=script&lang=js&"
export * from "./HeaderComparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121f4b85",
  null
  
)

export default component.exports